module.exports = __webpack_public_path__ + "img/entity_excel.f32a9cb2.svg";